// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Application List Styles
 * Styles for the application list component
 */

.application-list {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e9ecef;
  overflow: hidden;
  transition: all 0.3s ease;
}

.application-list:hover {
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #6c757d;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #0D3B66;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  color: #6c757d;
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-state h3 {
  margin: 0 0 0.5rem 0;
  color: #495057;
  font-size: 1.25rem;
  font-weight: 600;
}

.empty-state p {
  margin: 0;
  font-size: 1rem;
}

/* Table Styles */
.applications-table {
  width: 100%;
}

.applications-table .table-header {
  background: #252A33;
  color: white;
  border-bottom: 2px solid #E5E7EB;
}

.applications-table .table-row {
  border-bottom: 1px solid #dee2e6;
  transition: background-color 0.2s ease;
}

.applications-table .table-row:hover {
  background: #F7F7F8;
}

.applications-table .table-cell {
  padding: 1rem;
  vertical-align: middle;
}

/* Member ID */
.member-id {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #0D3B66;
  background: #FFF7ED;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
}

/* Organization Info */
.organization-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.organization-name {
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.875rem;
}

.organization-details {
  font-size: 0.75rem;
  color: #6c757d;
}

.location {
  display: inline-block;
}

/* Contact Info */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.contact-name {
  font-weight: 500;
  color: #2c3e50;
  font-size: 0.875rem;
}

.contact-email {
  font-size: 0.75rem;
  color: #6c757d;
  word-break: break-all;
}

/* Status Badge */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-pending {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.status-approved {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.status-rejected {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.status-suspended {
  background: #e2e3e5;
  color: #383d41;
  border: 1px solid #d6d8db;
}

.status-terminated {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* Date */
.date {
  font-size: 0.875rem;
  color: #6c757d;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.375rem 0.75rem;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 32px;
  height: 32px;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  min-width: 28px;
  height: 28px;
}

.btn-outline {
  background: white;
  border-color: #dee2e6;
  color: #6c757d;
}

.btn-outline:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
  color: #495057;
}

.btn-success {
  background: #28a745;
  color: white;
  border-color: #28a745;
}

.btn-success:hover {
  background: #218838;
  border-color: #1e7e34;
}

.btn-danger {
  background: #dc3545;
  color: white;
  border-color: #dc3545;
}

.btn-danger:hover {
  background: #c82333;
  border-color: #bd2130;
}

/* Responsive Design */
@media (max-width: 768px) {
  .application-list {
    border-radius: 8px;
  }

  .applications-table .table-cell {
    padding: 0.75rem 0.5rem;
  }

  .action-buttons {
    flex-direction: column;
    gap: 0.25rem;
  }

  .btn-sm {
    min-width: 24px;
    height: 24px;
    padding: 0.125rem 0.25rem;
  }
}

@media (max-width: 480px) {
  .applications-table .table-cell {
    padding: 0.5rem 0.25rem;
  }

  .organization-name,
  .contact-name {
    font-size: 0.8125rem;
  }

  .organization-details,
  .contact-email {
    font-size: 0.6875rem;
  }

  .status-badge {
    font-size: 0.6875rem;
    padding: 0.125rem 0.5rem;
  }

  .date {
    font-size: 0.8125rem;
  }
}

/* Enhanced Table Pagination */
.table-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-top: 1px solid #dee2e6;
  gap: 1rem;
}

.pagination-info {
  color: #6c757d;
  font-size: 0.9rem;
  font-weight: 500;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.pagination-page {
  color: #495057;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  min-width: 120px;
  text-align: center;
}

.pagination-controls .btn {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pagination-controls .btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #C2410C 0%, #FB923C 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(234, 88, 12, 0.3);
}

.pagination-controls .btn:disabled {
  background: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/components/applications/ApplicationList.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,6DAA6D;EAC7D,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/**\n * Application List Styles\n * Styles for the application list component\n */\n\n.application-list {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e9ecef;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.application-list:hover {\n  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);\n  transform: translateY(-1px);\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  color: #6c757d;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #0D3B66;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n  color: #6c757d;\n}\n\n.empty-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.empty-state h3 {\n  margin: 0 0 0.5rem 0;\n  color: #495057;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 1rem;\n}\n\n/* Table Styles */\n.applications-table {\n  width: 100%;\n}\n\n.applications-table .table-header {\n  background: #252A33;\n  color: white;\n  border-bottom: 2px solid #E5E7EB;\n}\n\n.applications-table .table-row {\n  border-bottom: 1px solid #dee2e6;\n  transition: background-color 0.2s ease;\n}\n\n.applications-table .table-row:hover {\n  background: #F7F7F8;\n}\n\n.applications-table .table-cell {\n  padding: 1rem;\n  vertical-align: middle;\n}\n\n/* Member ID */\n.member-id {\n  font-family: 'Courier New', monospace;\n  font-weight: 600;\n  color: #0D3B66;\n  background: #FFF7ED;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.875rem;\n}\n\n/* Organization Info */\n.organization-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.organization-name {\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: 0.875rem;\n}\n\n.organization-details {\n  font-size: 0.75rem;\n  color: #6c757d;\n}\n\n.location {\n  display: inline-block;\n}\n\n/* Contact Info */\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.contact-name {\n  font-weight: 500;\n  color: #2c3e50;\n  font-size: 0.875rem;\n}\n\n.contact-email {\n  font-size: 0.75rem;\n  color: #6c757d;\n  word-break: break-all;\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-pending {\n  background: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeaa7;\n}\n\n.status-approved {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.status-rejected {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.status-suspended {\n  background: #e2e3e5;\n  color: #383d41;\n  border: 1px solid #d6d8db;\n}\n\n.status-terminated {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n/* Date */\n.date {\n  font-size: 0.875rem;\n  color: #6c757d;\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.375rem 0.75rem;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 32px;\n  height: 32px;\n}\n\n.btn-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  min-width: 28px;\n  height: 28px;\n}\n\n.btn-outline {\n  background: white;\n  border-color: #dee2e6;\n  color: #6c757d;\n}\n\n.btn-outline:hover {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n  color: #495057;\n}\n\n.btn-success {\n  background: #28a745;\n  color: white;\n  border-color: #28a745;\n}\n\n.btn-success:hover {\n  background: #218838;\n  border-color: #1e7e34;\n}\n\n.btn-danger {\n  background: #dc3545;\n  color: white;\n  border-color: #dc3545;\n}\n\n.btn-danger:hover {\n  background: #c82333;\n  border-color: #bd2130;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .application-list {\n    border-radius: 8px;\n  }\n\n  .applications-table .table-cell {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  .btn-sm {\n    min-width: 24px;\n    height: 24px;\n    padding: 0.125rem 0.25rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .applications-table .table-cell {\n    padding: 0.5rem 0.25rem;\n  }\n\n  .organization-name,\n  .contact-name {\n    font-size: 0.8125rem;\n  }\n\n  .organization-details,\n  .contact-email {\n    font-size: 0.6875rem;\n  }\n\n  .status-badge {\n    font-size: 0.6875rem;\n    padding: 0.125rem 0.5rem;\n  }\n\n  .date {\n    font-size: 0.8125rem;\n  }\n}\n\n/* Enhanced Table Pagination */\n.table-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-top: 1px solid #dee2e6;\n  gap: 1rem;\n}\n\n.pagination-info {\n  color: #6c757d;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.pagination-page {\n  color: #495057;\n  font-weight: 600;\n  font-size: 0.9rem;\n  padding: 0.5rem 1rem;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #dee2e6;\n  min-width: 120px;\n  text-align: center;\n}\n\n.pagination-controls .btn {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  border: none;\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pagination-controls .btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #C2410C 0%, #FB923C 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(234, 88, 12, 0.3);\n}\n\n.pagination-controls .btn:disabled {\n  background: #e9ecef;\n  color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
